/**
 * Setting to be manually backfilled to separate the Framany+Nordics launch GTM audience between
 * retailers eligible for Special grandfathering (1+ european orders) and ineligible (0 european orders).
 */ export var INSIDER_SPECIAL_GRANDFATHERING_ELIGIBLE_230324 = 'INSIDER_SPECIAL_GRANDFATHERING_ELIGIBLE_230324';
